/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../Assests/Globalcss/stylesheet.css";
import hemb from "../../Assests/Globalimages/hemb-g.png";
import tick from "../../Assests/Globalimages/tick.png";
import visa from "../../Assests/Globalimages/visa.png";
import mastercard from "../../Assests/Globalimages/mastercard.png";
import american from "../../Assests/Globalimages/amrican-card.png";
// import discover from "../../Assests/Globalimages/discover.png";
import left_flower from "../../Assests/Globalimages/left-flower.png";
import arrival_bloom2 from "../../Assests/Globalimages/bloom (2).png";
import arrival_bloom1 from "../../Assests/Globalimages/bloom (1).png";

import will_get1 from "../../Assests/customImages/will-get-one.png";
import will_get2 from "../../Assests/customImages/will-get-two.png";

import will_get3 from "../../Assests/customImages/will-get-three.png";
import right_flower from "../../Assests/Globalimages/rigth-flower.png";
import discover from "../../Assests/Globalimages/discover.png";
import purple from "../../Assests/Globalimages/purpule.png";
import star_related from "../../Assests/Globalimages/star-related.png";
import marsale from "../../Assests/Globalimages/marsale.png";
import sil from "../../Assests/Globalimages/sil.png";
import hepm from "../../Assests/Globalimages/hepm.png";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";
import { useDispatch , useSelector } from "react-redux";
import {
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
  addToCart,
  addToCartWithQuantity
} from "../../Redux/cartSlice";
import { imageUrl } from "../../Config";
import { getRelatedProducts } from "../../Redux/Products/productSlice";
import ProductCard from "../../Componenets/ProductCard/ProductCard";
import { addToCart_db } from "../../Redux/db_Cart/db_cartSlice";
const index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

    const {products} = useSelector((state)=> state.products);
   
  const token = localStorage.getItem('token')
  const isDesktop = window.innerWidth > 768; // Check screen size
  const location = useLocation();
  const product = location.state?.product; // Get product data
  const [count , setCount] = useState(1)

  useEffect(()=>{ 
    dispatch(getRelatedProducts(product?.id))
  } ,[])

  const {relatedProducts} = useSelector((state)=>state.products);
  
  function addQuantity() {
    setCount(count+1)
  }

  function minusQuantity() {
    if(count <= 0){
      return;
    }
    setCount(count-1)
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 


  const addingtoCart =()=>{
    if(!token){
      dispatch(addToCartWithQuantity({product , quantity : count}))
    }
    else{
      dispatch(addToCart_db({ productId: product?.id, quantity: count }));
    }
  }


  console.log("available Colors " , product?.availableColors)
  return (
    <div>
      
      <section class="shope-now-section">
        <div class="container">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-8">
              <div class="content-shop-now text-center">
                <h3>Shop now </h3>
                <h1>Special orders are gratefully accepted. </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- new section lashlater --> */}
      <section class="lash-later">
        <div class="container">
          <div class="row d-flex justify-content-center">
            <div class="col-lg-6 col-md-8 ">
              <div class="content-lash-later" style={{background:product?.bgColor}}>
                <img src={imageUrl+product?.imageUrl} class="img-fluid hemb-pic" alt="" />
              </div>
            </div>
            <div class="col-lg-6 col-md-8">
              <div class="text-content-shop-now">
                <h1>{product?.name} {" "} <span style={{color:'orange'}}>${product?.price}</span></h1> 
                <p>
                  {product?.description}natural and often luxurious cleansing experience, crafted with carefully selected ingredients like essential oils, herbs, and botanicals..{" "}
                </p>
                
                {/* Color Selection Section */}
                {product?.availableColors.length > 0 && (
                  <div class="color-selection mb-3">
                    <h6>Available Colors:</h6>
                    <div class="d-flex flex-wrap gap-2">
                      {JSON.parse(product?.availableColors).map((color, index) => (
                        <div 
                          key={index}
                          style={{
                            width: '30px',
                            height: '30px',
                            backgroundColor: color,
                            borderRadius: '50%',
                            border: '1px solid #ddd',
                            cursor: 'pointer'
                          }}
                          title={color}
                        />
                      ))}
                    </div>
                  </div>
                )}
                
                <div class="shop-cart d-flex flex-wrap">
                  <div class="d-flex align-items-center">
                    <div class="minus" onClick={()=>minusQuantity()}>
                      <i class="fas fa-minus mins-icone"></i>
                    </div>
                    <div id="quantity" class="quantity mx-2">
                      {count}
                    </div>
                    <div class="plus" onClick={()=>addQuantity()}>
                      <i class="fas fa-plus plus-icone"></i>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary ms-3"
                    onClick={() => addingtoCart()}
                  >
                    Add to cart
                  </button>
                </div>
                
                <div class="paras-lash-later">
                  <div class="img-para d-flex align-items-center">
                    <img src={tick} class="img-fluid tick" alt="" />
                    <p class="no-risk">No-Risk Money Back Guarantee!</p>
                  </div>
                  <div class="img-para d-flex align-items-center">
                    <img src={tick} class="img-fluid tick" alt="" />
                    <p class="no-risk">Gentle on Sensitive Skin</p>
                  </div>
                  <div class="img-para d-flex align-items-center">
                    <img src={tick} class="img-fluid tick" alt="" />
                    <p class="no-risk">Handmade with Love in Small Batches</p>
                  </div>
                  <div class="img-para d-flex align-items-center">
                    <img src={tick} class="img-fluid tick" alt="" />
                    <p class="no-risk">Eco-Friendly Packaging</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- newsection is started name guraanted  --> */}
      <section class="guranter">
        <div class="container">
          <div
            class="row d-flex justify-content-center pb-5 rounded"
            style={{ background: " #F5A3B74A", paddingBottom: "40px;" }}
          >
            <div class="headimg-guranted">
              <h2>Guaranteed Safe Checkout</h2>
            </div>
            <div class="col-lg-8">
              <div class="row d-flex justify-content-left align-items-center">
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="content-guiranted-img">
                    <div class="first-imges">
                      <img src={visa} class="img-fluid visa" alt="" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="content-guiranted-img">
                    <div class="first-imges">
                      <img src={mastercard} class="img-fluid master" alt="" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="content-guiranted-img">
                    <div class="first-imges">
                      <img src={american} class="img-fluid american" alt="" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="content-guiranted-img">
                    <div class="first-imges">
                      <img src={discover} class="img-fluid discover" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- new section related product  --> */}
      {relatedProducts?.length > 0 && (
         <section class="related-product">
         <div class="container">
           <div class="heading-related position-relative">
             <img src={left_flower} class="img-fluid left-flower" alt="" />
             <h3>Related products</h3>
             <img src={right_flower} class="img-fluid right-flower" alt="" />
           </div>
           <div class="row d-flex justify-content-start">
 
           {relatedProducts?.map((product) => (
              < ProductCard product={product}/> 
             ))}
             {relatedProducts.length == 0 && (
               <div className="text-center fw-bold fs-10">No Related Products found</div>
             )}
 
            
           </div>
         </div>
       </section>
      )}
     
 

      <section class="free_shepping_section" style={{background:'#f7f7f7',marginTop:35 , paddingTop : '4%' , paddingBottom : '4%'}}>
        <div class="container">
          <div class="row d-flex justify-content-center"  >
            {/* <div class="shope_now" style={{}}>
              <img src={arrival_bloom2} alt="" />
              <h4 style={{textTransform:'capitalize'}}>you will get</h4>
              <img src={arrival_bloom1} alt="" />
            </div> */}
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get1} alt="" />
                              <h4 style={{fontSize:20, fontWeight:600}}>Season Sale</h4>
                <p >
                Pamper your skin for less! Enjoy special seasonal discounts on our handcrafted goat milk soaps. Treat yourself or someone you love to nourishing skincare at unbeatable prices. Shop now your skin will thank you!
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get2} alt="" />
                <h4 style={{fontSize:20, fontWeight:600}}> Shipping</h4>
                <p >
                We know you can’t wait to experience the goodness of our goat milk soap. That’s why we offer quick and secure shipping straight to your door with tracking available on every order.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get3} alt="" />

                <h4 style={{fontSize:20, fontWeight:600}}>Money Back Gurantee</h4>
                <p >
                We care about happy skin and happy customers! If you're not completely satisfied with our soap, we offer a full money-back guarantee. Shop with confidence your satisfaction is our promise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default index;
